import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=5dd64b22"
import script from "./trash.vue?vue&type=script&lang=js"
export * from "./trash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports